// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'skota-official',
    appId: '1:413650519502:web:4b95b2604db7141cbf579f',
    storageBucket: 'skota-official.appspot.com',
    apiKey: 'AIzaSyC3GZOAl43wmk5rh6-DELNI8dsY_tAdpv0',
    authDomain: 'skota-official.firebaseapp.com',
    messagingSenderId: '413650519502',
    measurementId: 'G-E0BLWTRH08',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
